import React, { useEffect } from "react";

import Icon_MidstreamSalesFacilities from "components/icons/Icon_MidstreamSalesFacilities";
import { useMapContext } from "components/map/hooks/useMapContext";
import {
  midstreamNavigatorActions,
  useMidstreamNavigatorContext
} from "components/midstream/midstream-navigator/context/MidstreamNavigatorContext";

import { FilterKey, useFilterButtonContext } from "../context/FilterButtonContext";
import { BaseMidstreamFilterButton, FilterConfig } from "../filters/BaseFilterButton";
import { useFilterToSalesFacilities } from "../hooks/useFilterToSalesFacilities";

export const SalesFacilitiesButton: React.FC = () => {
  const [state, dispatch] = useMidstreamNavigatorContext();
  const { mapbox } = useMapContext();
  const {
    getIsDisabled,
    withUserAction,
    useExternalFilterMonitoring,
    MonitoringStrategies
  } = useFilterButtonContext();
  const { filterToSalesFacilities, removeFilterToSalesFacilities } =
    useFilterToSalesFacilities(mapbox);

  const config: FilterConfig = {
    icon: <Icon_MidstreamSalesFacilities />,
    tooltip: "Filter to Sales Facilities for Selected Well",
    testId: `filter-button-${FilterKey.SalesFacilities}`
  };

  const isActive = state.activeFilters?.includes(FilterKey.SalesFacilities) ?? false;
  const isDisabled = getIsDisabled(FilterKey.SalesFacilities, isActive);
  const disabledReason = isDisabled ? "Select a well to display sales facilities" : null;

  // Use custom monitoring strategy for sales facilities
  useExternalFilterMonitoring(
    FilterKey.SalesFacilities,
    isActive,
    MonitoringStrategies.salesFacilities
  );

  // Auto-cleanup when button becomes disabled while active
  useEffect(() => {
    if (isDisabled && isActive) {
      // Button became disabled while active - clean up the filter
      dispatch(midstreamNavigatorActions.removeFilter(FilterKey.SalesFacilities));
      removeFilterToSalesFacilities();
    }
  }, [isDisabled, isActive, dispatch, removeFilterToSalesFacilities]);

  const handleToggle = () => {
    withUserAction(() => {
      if (!isActive) {
        dispatch(midstreamNavigatorActions.addFilter(FilterKey.SalesFacilities));
        filterToSalesFacilities();
      } else {
        dispatch(midstreamNavigatorActions.removeFilter(FilterKey.SalesFacilities));
        removeFilterToSalesFacilities(true);
      }
    });
  };

  return (
    <BaseMidstreamFilterButton
      config={config}
      isActive={isActive}
      isDisabled={isDisabled}
      disabledReason={disabledReason}
      onToggle={handleToggle}
    />
  );
};
